import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHero from "@/components/layout/PageHero";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { BlogCard } from "@/components/home/BlogTeasers";

const CATEGORIES = ["All", "Destination Guides", "Travel Tips", "Visa Guides", "Airline Reviews", "Hotel Reviews", "Budget Travel"];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => {
    const q = cat === "All" ? "" : `?category=${encodeURIComponent(cat)}`;
    api.get(`/blog${q}`).then(({ data }) => setPosts(data)).catch(() => {});
  }, [cat]);

  return (
    <div data-testid="blog-page">
      <PageHero
        kicker="MyTripPoint Blog"
        title="Travel stories, tips and reviews"
        subtitle="Honest writing from real travellers — destination guides, hotel reviews, visa playbooks and budget hacks."
      />
      <div className="container-page py-10">
        <Breadcrumbs items={[{ label: "Blog" }]} />
        <div className="flex flex-wrap gap-2 mb-6">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`blog-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider border ${
                cat === c ? "bg-brand text-white border-brand" : "bg-white text-slate-600 border-slate-200 hover:border-brand"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {posts.map((p) => <BlogCard key={p.slug} post={p} />)}
        </div>
      </div>
    </div>
  );
}
